import { Component, OnInit } from '@angular/core';
import { SurveyJobsService } from './services/surveyjobs.service';
import { ISurveys, IJob, IJobRegion } from './Interface/Interface';
import { Constants } from './Constants/Constants';
import { ActivatedRoute } from '@angular/router';

declare var $: any;
declare global {
  interface Window { dataLayer: any[]; }
}


function ResetSurveyDropDown() {
  $("#dlSurveys").val($("#dlSurveys option:first").val());

}

function ResetRegionsDropDown() {
  $("#dlRegions").val($("#dlRegions option:first").val());

}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  searchData: string = "";
  ParamString: string;
  Param2String: string;
  resultsDisplayString: string;
  querystringsearchData: any;
  searchresults: IJob[];
  filteredsearchresults: IJob[];
  pagePageItems: IJob[];
  checkedSearchresults: IJob[];
  selectedSearchresults: IJob[];
  DefaultSurvey: ISurveys
  Surveys: ISurveys[];
  OriginalSurveys: ISurveys[];
  Regions: IJobRegion[];
  count: number = 0;
  loadPage: boolean = true;
  websiteUrl: string = "";
  error: boolean = false;
  pager: any = {};
  pagedItems: any[];
  page = 1;
  SurveyId: string = "";
  sortASC: boolean = true;
  surveySelected: boolean = true;
  noitemsinSearch: boolean = false;
  selectedCultureCode: string = "All";
  searchcount: number = 0;
  constructor( private _SurveyJobsService: SurveyJobsService, private activateRoute: ActivatedRoute) {

  }
  ngOnInit() {
    this.GetAllRegions();
    this.GetAllActiveSurveysWithJobs("All");
    this.searchData = "";
  }

  GetAllRegions() {
    this._SurveyJobsService.GetAllRegions(Constants.GetAllRegions).subscribe(
      data => {
        this.Regions = JSON.parse(data);
        this.loadPage = true;
      }
    )
  }

  GetAllActiveSurveysWithJobs(cultureCode) {
    this.loadPage = false;
    if (cultureCode.toLowerCase() === "en-us") {
      this.DefaultSurvey = { SurveyId: "0", SurveyName: "Select US survey" };
    }
    else if (cultureCode.toLowerCase() === "en-ca") {
      this.DefaultSurvey = { SurveyId: "0", SurveyName: "Select Canada survey" };
    }
    else {
      this.DefaultSurvey = { SurveyId: "0", SurveyName: "Select survey" };
    }
    this._SurveyJobsService.GetAllActiveSurveysWithJobs(Constants.GetAllActiveSurveysWithJobs, cultureCode).subscribe(
      data => {
        this.Surveys = []
        this.Surveys.push(this.DefaultSurvey);
        this.Surveys = this.Surveys.concat(JSON.parse(data));
        this.OriginalSurveys = this.Surveys;
        this.loadPage = true;
      }
    )
  }

  pushevent(RegionName, searchterm, searchCount) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = "window.dataLayer = window.dataLayer || []; dataLayer.push({event: 'viewSurveyResults', search_term: " + "'" + searchterm + "', region: '" + RegionName + "'," + " results: " + searchCount + "});"
    document.head.appendChild(script);
  }

  onRegionChange(value: string) {
    if (value === "0") {
      this.selectedCultureCode = "All"
    }
    else {
      this.selectedCultureCode = value;
    }
    this.GetAllActiveSurveysWithJobs(this.selectedCultureCode);
  }


  onSurveyChange(e) {
    if (e.target.value != undefined && e.target.value !="0") {
      this.surveySelected = true;
    }
    this.SurveyId = e.target.value;
    this.noitemsinSearch = false;
    this.GetSearchResults(e.target.options[e.target.options.selectedIndex].text);
  }

  GetSearchResults(SurveyName) {    
    this.error = false;
    this.loadPage = false;
    this.noitemsinSearch = false;
    this._SurveyJobsService.GetJobsBySurveyId(Constants.GetJobsBySurveyId, this.SurveyId, "0").subscribe(
      data => {
        this.searchresults = JSON.parse(data);
        this.loadPage = true;
        if (this.searchresults.length > 0) {
          this.SetPagination(this.searchresults, 0);
          var pageSizeDisplay = "";
          if (this.searchresults.length < this.pager.pageSize) {
            pageSizeDisplay = this.searchresults.length.toString();
          }
          else {
            pageSizeDisplay = this.pager.pageSize.toString();
          }
          this.resultsDisplayString = "1-" + pageSizeDisplay + " of " + this.searchresults.length.toString();
        }
        else {
          this.noitemsinSearch = true;
          this.filteredsearchresults = [];
        }
        var regionname = "United States/Canada";
        if (this.selectedCultureCode.toLowerCase() == "en-ca") {
          regionname = "Canada"
        }
        else if (this.selectedCultureCode.toLowerCase() == "en-us") {
          regionname = "United States"
        }
        this.pushevent(regionname, SurveyName, this.searchresults.length);
      }
    )
    this.sortASC = true;
    return false;
  }


  ClearSearch() {
    this.searchData = "";
    this.SurveyId = "";
    this.searchresults = [];
    this.filteredsearchresults = [];
    this.noitemsinSearch = false;
    ResetRegionsDropDown();
    this.GetAllActiveSurveysWithJobs("All")
    return false;
  }

  SearchByText() {
    this.error = false;
    this.loadPage = false;
    this.noitemsinSearch = false;
    ResetSurveyDropDown();
    //ResetRegionsDropDown();
    this._SurveyJobsService.GetJobsBySearchText(Constants.GetJobsBySearchText, this.selectedCultureCode, this.SurveyId, this.searchData, "0").subscribe(
        data => {
          this.searchresults = JSON.parse(data);
          this.loadPage = true;
          if (this.searchresults.length > 0) {
            this.SetPagination(this.searchresults, 0);
            var pageSizeDisplay = "";
            if (this.searchresults.length < this.pager.pageSize) {
              pageSizeDisplay = this.searchresults.length.toString();
            }
            else {
              pageSizeDisplay = this.pager.pageSize.toString();
            }
            this.resultsDisplayString = "1-" + pageSizeDisplay + " of " + this.searchresults.length.toString();
          }
          else {
            this.noitemsinSearch = true;
            this.filteredsearchresults = [];
          }
          var regionname = "United States/Canada";
          if (this.selectedCultureCode.toLowerCase() == "en-ca") {
            regionname = "Canada"
          }
          else if (this.selectedCultureCode.toLowerCase() == "en-us") {
            regionname = "United States"
          }
          this.pushevent(regionname, this.searchData, this.searchresults.length);
        }
    )

      this.sortASC = true;
      return false;
  }

  SortByJobCode() {
    var sortedfilteredsearchresults;
    if (this.sortASC == true) {
      sortedfilteredsearchresults = this.filteredsearchresults.sort((a, b) => a.JobCode.localeCompare(b.JobCode));
    }
    else {
      sortedfilteredsearchresults = this.filteredsearchresults.sort((b, a) => a.JobCode.localeCompare(b.JobCode));
    }
    this.filteredsearchresults = sortedfilteredsearchresults;
    if (this.sortASC == true) {
      this.sortASC = false;
    }
    else {
      this.sortASC = true;
    }
    return false;
  }

  SortByPositionTitle() {
    var sortedfilteredsearchresults;
    if (this.sortASC == true) {
      sortedfilteredsearchresults = this.filteredsearchresults.sort((a, b) => a.JobCode.localeCompare(b.PositionTitle));
    }
    else {
      sortedfilteredsearchresults = this.filteredsearchresults.sort((b, a) => a.JobCode.localeCompare(b.PositionTitle));
    }
    this.filteredsearchresults = sortedfilteredsearchresults;
    if (this.sortASC == true) {
      this.sortASC = false;
    }
    else {
      this.sortASC = true;
    }
    return false;
  }


  SetPagination(currentSearchresults: IJob[], pageIndex: number) {
    if (currentSearchresults == null) {
      currentSearchresults = this.searchresults;
    }
    this.count = currentSearchresults.length;
    this.page = pageIndex + 1;
    this.pager = this._SurveyJobsService.getPager(this.count, this.page);
    this.filteredsearchresults = currentSearchresults.slice(this.pager.startIndex, this.pager.endIndex + 1);
    if (this.pager.currentPage) {
      this.pager.currentPage = pageIndex + 1;
    }
  }


  setPage(cpage: number) {
    var totalPage = this.count / 20;
    if (cpage < 1 || cpage > totalPage + 1) {
      return;
    }
    if (cpage === this.pager.currentPage) {
      return;
    }
    this.page = cpage;
    // get pager object from service
    //this.pager = this._maintenanceService.getPager(this.count, this.page);
    this.SetPagination(this.selectedSearchresults, cpage - 1);
  }

  sortOn(property) {
    return function (a, b) {
      if (a[property] < b[property]) {
        return -1;
      } else if (a[property] > b[property]) {
        return 1;
      } else {
        return 0;
      }
    }
  }
}

